import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';
import { toast } from 'sonner';

/**
 * AuthCallback handles the OAuth return from Emergent Google Auth.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id in URL');
          toast.error('Anmeldung fehlgeschlagen');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for token
        const response = await api.post('/auth/google/session', {
          session_id: sessionId
        });

        const { token, user } = response.data;

        // Store token
        localStorage.setItem('token', token);

        // Refresh user in context
        await refreshUser();

        // Show success message
        toast.success(`Willkommen${user.contact_name ? ', ' + user.contact_name : ''}!`);

        // Check if profile needs completion
        if (user.needs_profile_completion) {
          toast.info('Bitte vervollständigen Sie Ihr Profil');
          navigate('/profile', { replace: true, state: { user } });
        } else {
          navigate('/', { replace: true, state: { user } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        const errorMessage = error.response?.data?.detail || 'Anmeldung fehlgeschlagen';
        toast.error(errorMessage);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-lg text-gray-600">Anmeldung wird verarbeitet...</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
